import ViewAdministrator from "../../../../components/@users/administrators/ViewAdministrator";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function AdministratorViewPage() {

    return (
        <ViewAdministrator 
            routeType={routeTypes.admin}
        />
    )
}       